/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Edit = ({ color = 'forest', height = 20, width = 20 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${height} ${width}`}
      sx={{ fill: color }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10.21V20H0V.42h10V2.38H2v15.663h16V10.21h2zm-13 .304l8.022-7.869 1.554 1.998-8.117 8.504H7v-2.633zm-2 4.591h4.316l9.907-10.46L15.076 0 5 9.688v5.417z"
        fill={color}
      />
    </svg>
  )
}

Edit.propTypes = {
  color: string,
  height: number,
  width: number,
}

export default Edit
